export const TeacherGradeCourseType = {
  normalCourse: 'normal_course',
  polishingCourse: 'polishing_course',
};

export const DEFAULT_TEACHER_GRADE_COURSE_TYPE = TeacherGradeCourseType.normalCourse;

export const TeacherGradeCourseTypeLabel = {
  [TeacherGradeCourseType.normalCourse]: '正常课程',
  [TeacherGradeCourseType.polishingCourse]: '润色课程',
};

export const normalizeTeacherGradeCourseType = (value) =>
  Object.values(TeacherGradeCourseType).includes(value)
    ? value
    : DEFAULT_TEACHER_GRADE_COURSE_TYPE;

export const getTeacherGradeCourseTypeLabel = (value) =>
  TeacherGradeCourseTypeLabel[normalizeTeacherGradeCourseType(value)];

export const TeacherGradeOptions = ['A', 'B+', 'B', 'B-', 'C', 'D'].map((grade) => ({
  label: grade,
  value: grade,
}));

export const TeacherGradeCourseTypeOptions = Object.values(TeacherGradeCourseType).map((value) => ({
  label: TeacherGradeCourseTypeLabel[value],
  value,
}));
